export const OrderStatus = [
  {
    code: "ProductionApproval",
    filterString: "Production Approval",
    name: "PENDING APPROVAL",
    button_text: "APPROVE",
    button_icon: "solid/check",
  },
  {
    code: "ProductionScheduled",
    filterString: "Production Scheduled",
    name: "ORDER PROCESSING",
    button_text: "SEND TO PRODUCTION",
    button_icon: "solid/paper-plane",
  },
  {
    code: "InProduction",
    filterString: "In Production",
    name: "IN PRODUCTION",
    button_text: "Production Completed",
    button_icon: "solid/box-archive",
  },
  {
    code: "ProductionCompleted",
    filterString: "Production Completed",
    name: "PRODUCTION COMPLETED",
    button_text: "DISPATCHED",
    button_icon: "solid/truck",
  },
  {
    code: "Dispatched",
    filterString: "Dispatched",
    name: "DISPATCHED",
    button_text: "RESEND INFORMATION",
    button_icon: "solid/share",
  },
  { code: "Completed", name: "COMPLETED" },
];

export const OrderStates = [
  {
    code: null,
    name: "All",
  },
  {
    code: "DRFT",
    name: "Draft",
  },
  {
    code: "EST",
    name: "Estimate",
  },
  {
    code: "ORD",
    name: "Order",
  },
  {
    code: "QOT",
    name: "Quote",
  },
];

export const OrderStatusNew = [
  {
    code: "Draft",
    name: "Draft",
  },
  {
    code: "Awaiting Payment on Account",
    name: "Awaiting Payment on Account",
  },
  {
    code: "Finance Approval",
    name: "Finance Approval",
  },
  {
    code: "Production Approval",
    name: "Production Approval",
  },
  {
    code: "Production Scheduled",
    name: "Production Scheduled",
  },
  {
    code: "In Production",
    name: "In Production",
  },
  {
    code: "Production Completed",
    name: "Production Completed",
  },
  {
    code: "Dispatched",
    name: "Dispatched",
  },
  {
    code: "Awaiting Payment",
    name: "Awaiting Payment",
  },
  {
    code: "Completed",
    name: "Completed",
  },
  {
    code: "Cancelled",
    name: "Cancelled",
  },
];
